const SvgComputeandServers1 = (props) => (
  <>
    <path
      d="M0 0v48h192V0H0Zm168 32c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8ZM0 72v48h192V72H0Zm168 32c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8ZM0 144v48h192v-48H0Zm168 32c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Z"
      fill={props.p20}
    />
  </>
);

export default SvgComputeandServers1;
